<template>
  <div class="setBox">
    <div class="them">账户设置</div>
    <!--    老用户展示-->
    <div class="remark" v-if="!userinfo.is_set_password && !phone">
      <img src="@/assets/img/ico_t.png" alt="" /><span class="text"
        >请修改初始密码，并绑定手机号</span
      >
    </div>

    <el-form label-position="top" label-width="120px" class="formTotal">
      <el-row>
        <el-col :span="10">
          <el-form-item label="企业名称">
            <el-input v-model="userinfo.company_info.name" disabled></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="10">
          <el-form-item label="手机号码">
            <el-input :value="phone" disabled></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="2">
          <div v-if="phone" class="btn" @click="dialogVisible1 = true">
            换绑手机
          </div>
          <div v-else class="btn" @click="dialogVisible = true">绑定手机</div>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="10">
          <el-form-item label="密码">
            <el-input type="password" placeholder="******" disabled></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="2">
          <div class="btn" @click="pswDialogVisible = true">修改</div>
        </el-col>
      </el-row>
    </el-form>
    <!--绑定手机号-->
    <!--    :before-close="handleClose"-->
    <el-dialog
      title="绑定手机号"
      :close-on-click-modal="false"
      :visible.sync="dialogVisible"
      width="420px"
    >
      <el-form
        label-position="top"
        :model="iphoneForm"
        :rules="iphoneRules"
        ref="iphoneForm"
        label-width="120px"
        class="formTotal"
      >
        <el-row>
          <el-col :span="24">
            <el-form-item label="手机号" prop="phone">
              <el-input
                placeholder="请输入手机号"
                v-model="iphoneForm.phone"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="24" style="margin-top: 20px; position: relative">
            <el-form-item label="验证码" prop="captcha">
              <el-input
                placeholder="请输入验证码"
                v-model="iphoneForm.captcha"
              ></el-input>
            </el-form-item>
            <div class="send">
              <SendCode :mobile="iphoneForm.phone" type="bindPhone"
                >发送验证码
              </SendCode>
            </div>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="bindPhone()">确 定</el-button>
      </span>
    </el-dialog>
    <!--换绑手机号-->
    <!--    1.验证前手机号-->
    <el-dialog
      title="换绑手机号"
      :close-on-click-modal="false"
      :visible.sync="dialogVisible1"
      width="420px"
    >
      <el-form
        label-position="top"
        :model="validOldPhoneForm"
        :rules="validOldPhoneRules"
        ref="validOldPhoneForm"
        label-width="120px"
        class="formTotal"
      >
        <el-row>
          <el-col :span="24">
            <el-form-item label="原手机号" prop="phone">
              <el-input
                disabled
                placeholder="请输入原手机号"
                v-model="validOldPhoneForm.phone"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="24" style="margin-top: 20px; position: relative">
            <el-form-item label="验证码" prop="captcha">
              <el-input
                placeholder="请输入验证码"
                v-model="validOldPhoneForm.captcha"
              ></el-input>
            </el-form-item>
            <div class="send">
              <SendCode :mobile="validOldPhoneForm.phone" type="valid"
                >发送验证码
              </SendCode>
            </div>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="validPhone()">下一步</el-button>
      </span>
    </el-dialog>
    <!--    2.换绑新手机号-->
    <el-dialog
      title="换绑新手机号"
      :close-on-click-modal="false"
      :visible.sync="dialogVisible2"
      width="420px"
    >
      <el-form
        label-position="top"
        :model="validNewPhoneForm"
        :rules="validNewPhoneRules"
        ref="validNewPhoneForm"
        label-width="120px"
        class="formTotal"
      >
        <el-row>
          <el-col :span="24">
            <el-form-item label="新手机号" prop="phone">
              <el-input
                placeholder="请输入新手机号"
                v-model="validNewPhoneForm.phone"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="24" style="margin-top: 20px; position: relative">
            <el-form-item label="验证码" prop="captcha">
              <el-input
                placeholder="请输入验证码"
                v-model="validNewPhoneForm.captcha"
              ></el-input>
            </el-form-item>
            <div class="send">
              <SendCode :mobile="validNewPhoneForm.phone" type="bindPhone"
                >发送验证码
              </SendCode>
            </div>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="changePhone()">确定</el-button>
      </span>
    </el-dialog>
    <!--修改密码-->
    <el-dialog
      title="修改密码"
      :close-on-click-modal="false"
      :visible.sync="pswDialogVisible"
      width="420px"
    >
      <el-form
        label-position="top"
        :model="pswForm"
        :rules="rules2"
        ref="pswForm"
        label-width="120px"
        class="formTotal"
      >
        <el-row>
          <el-col :span="24">
            <el-form-item label="旧密码" prop="old_password">
              <el-input
                placeholder="请输入旧密码"
                v-model="pswForm.old_password"
                type="password"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="24" style="margin-top: 20px; position: relative">
            <el-form-item label="新密码" prop="new_password">
              <el-input
                placeholder="请输入新密码"
                v-model="pswForm.new_password"
                type="password"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="24" style="margin-top: 20px; position: relative">
            <el-form-item label="确认密码" prop="new_password_a">
              <el-input
                v-model="pswForm.new_password_a"
                placeholder="请再次确定新密码"
                type="password"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="pswDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="subPsw()">确认修改</el-button>
      </span>
    </el-dialog>
    <!--    操作提示-->
    <el-dialog
      title="操作提示"
      :visible.sync="tipDialogVisible"
      width="540px"
      :close-on-click-modal="false"
    >
      <div class="tip">
        <img src="@/assets/img/ico_t.png" alt="" />
        <span>请先{{ showTips }}！</span>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="handleClose()">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { getUserInfo } from "@/api/company.js";
import {
  updatePassword,
  set_mobile,
  validOldPhone,
  changeBindPhone,
} from "@/api/setAccount.js";
import SendCode from "@/components/common/SendCode";

export default {
  name: "setAccount",
  components: {
    SendCode,
  },
  computed: {
    ...mapState(["userinfo"]),
  },
  mounted() {
    // console.log("userinfo", this.userinfo);
  },
  data() {
    const validatePass1 = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请再次输入密码"));
      } else if (this.pswForm.new_password !== this.pswForm.new_password_a) {
        callback(new Error("两次输入密码不一致!"));
      } else {
        callback();
      }
    };
    return {
      phone: "", // 显示用的手机
      showTips: "", // 显示要绑定的信息
      //绑定手机号
      iphoneForm: {
        phone: "", //手机
        captcha: "", //验证码
      },
      //验证原手机号
      validOldPhoneForm: {
        phone: "", //手机
        captcha: "", //验证码
      },
      //换绑手机号
      validNewPhoneForm: {
        phone: "", //手机
        captcha: "", //验证码
      },
      pswForm: {
        old_password: "", //旧密码
        new_password: "", //新密码
        new_password_a: "", //再次确认 新密码
      },
      //绑定手机弹窗
      dialogVisible: false, //绑定手机号
      dialogVisible1: false, //换绑 第一步 验证手机号
      dialogVisible2: false, //换绑 第二步 新手机号
      tipDialogVisible: false, //老用户一进来的提示框
      pswDialogVisible: false,
      isNewUser: false, //是新用户吗
      rules2: {
        old_password: [
          {
            required: true,
            message: "请输入旧密码",
            trigger: "blur",
          },
          {
            min: 6,
            max: 20,
            message: "密码长度在6-20位之间",
            trigger: "blur",
          },
        ],
        new_password: [
          {
            required: true,
            message: "请输入新密码",
            trigger: "blur",
          },
          {
            min: 6,
            max: 20,
            message: "密码长度在6-20位之间",
            trigger: "blur",
          },
        ],
        new_password_a: [
          {
            required: true,
            message: "请再次确定新密码",
            trigger: "blur",
          },
          { validator: validatePass1, trigger: "blur" },
        ],
      },
      iphoneRules: {
        phone: [
          {
            required: true,
            message: "请输入手机号",
            trigger: "blur",
          },
        ],
        captcha: [
          {
            required: true,
            message: "请输入验证码",
            trigger: "blur",
          },
        ],
      },
      validOldPhoneRules: {
        phone: [
          {
            required: true,
            message: "请输入原手机号",
            trigger: "blur",
          },
        ],
        captcha: [
          {
            required: true,
            message: "请输入验证码",
            trigger: "blur",
          },
        ],
      },
      validNewPhoneRules: {
        phone: [
          {
            required: true,
            message: "请输入新手机号",
            trigger: "blur",
          },
        ],
        captcha: [
          {
            required: true,
            message: "请输入验证码",
            trigger: "blur",
          },
        ],
      },
    };
  },
  created() {
    this.init();
  },
  methods: {
    //操作提示关闭弹窗
    handleClose() {
      this.tipDialogVisible = false;
      // 更新状态可以用
      // this.$store.commit("setUserInfo", this.userinfo);
    },
    async init() {
      await this.londUserInfo();
      if (this.userinfo.is_set_password && this.phone) {
        this.tipDialogVisible = false;
      } else {
        let temp = [];
        // 判断电话有没有绑定过
        if (this.userinfo.is_set_password === false) {
          temp.push("修改初始密码");
        }
        // 判断登录密码
        if (!this.phone) {
          temp.push("绑定手机号");
        }
        this.showTips = temp.join("，");
        this.tipDialogVisible = true;
      }
    },

    // 更新用户信息
    async londUserInfo() {
      const res = await getUserInfo();
      let userInfoTemp = this.$store.state.userinfo;

      let companyInfo = userInfoTemp.company_info;

      companyInfo.phone = res.phone;
      userInfoTemp.company_info = companyInfo;

      userInfoTemp.token = res.token;
      userInfoTemp.phone = res.phone;
      if (res.phone) {
        this.phone = res.phone;
      }
      this.iphoneForm.phone = res.phone;

      this.validOldPhoneForm.phone = this.iphoneForm.phone;

      userInfoTemp.is_set_password = res.is_set_password;
      this.$store.commit("setUserInfo", userInfoTemp);
      // console.log("查询到用户信息", userInfoTemp);
    },
    //确认修改密码
    async subPsw() {
      this.$refs.pswForm.validate(async (valid) => {
        if (valid) {
          delete this.pswForm.new_password_a;
          await updatePassword(this.pswForm);
          this.$message.success("密码修改成功！");
          this.userinfo.is_set_password = true;
          //这种写法大错特错，这样就用一个值更新了全部
          // this.$store.commit("userinfo", this.userinfo.is_set_password);
          //正确写法：
          this.$store.commit("userinfo", this.userinfo);
          // console.log("修改密码后", this.userinfo);
          this.pswDialogVisible = false;
        } else {
          return false;
        }
      });
    },
    //绑定手机
    async bindPhone() {
      this.$refs.iphoneForm.validate(async (valid) => {
        if (valid) {
          this.dialogVisible = false;
          // delete this.pswForm.new_password_a;
          const res = await set_mobile(this.iphoneForm);
          if (res) {
            await this.londUserInfo();
          }
          this.$message.success("绑定成功！");
        } else {
          this.$message.success("请填写手机号和验证码");
          return false;
        }
      });
    },
    //换绑 先验证原手机号
    async validPhone() {
      this.$refs.validOldPhoneForm.validate(async (valid) => {
        if (valid) {
          const res = await validOldPhone(this.validOldPhoneForm);
          if (res && res.result) {
            this.$message.success("验证成功！");
            //清空表单
            this.validOldPhoneForm.captcha = null;
            //关闭第一步弹窗
            this.dialogVisible1 = false;
            //打开换绑新手机的弹窗
            this.dialogVisible2 = true;
          }
        } else {
          this.$message.error("请填写验证码");
          return false;
        }
      });
    },
    // 换绑 新手机号
    async changePhone() {
      this.$refs.validNewPhoneForm.validate(async (valid) => {
        if (valid) {
          const res = await changeBindPhone(this.validNewPhoneForm);
          if (res) {
            this.$message.success("换绑成功！");
            //清空表单
            this.validNewPhoneForm.captcha = null;
            // 打开换绑新手机的弹窗
            this.dialogVisible2 = false;
            //同时更新页面上的显示
            this.londUserInfo();
          }
        } else {
          this.$message.error("请填写验证码");
          return false;
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.setBox {
  background: #ffffff;
  border-radius: 2px;
  padding: 16px 20px 60px;

  .them {
    font-size: 20px;
    color: #333;
  }

  .remark {
    background: #eaf4ff;
    border: 1px solid #d2e7fb;
    border-radius: 2px;
    margin-top: 23px;
    display: flex;
    align-items: center;
    padding-left: 12px;
    height: 32px;

    img {
      width: 13px;
      height: 13px;
    }

    .text {
      font-size: 12px;
      color: #333333;
      margin-left: 5px;
    }
  }

  .formTotal {
    margin-top: 30px;
    padding-left: 20px;

    .btn {
      width: 100px;
      height: 36px;
      border: 1px solid #4379f6;
      margin-left: 20px;
      font-size: 14px;
      color: #4379f6;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-top: 32px;
      cursor: pointer;
    }

    .send {
      position: absolute;
      top: 41px;
      cursor: pointer;
      right: 12px;
      font-size: 14px;
      color: #4379f6;
    }

    /deep/ .el-form-item__label {
      font-size: 12px;
      color: #666666;
      line-height: unset;
      margin-bottom: 5px;
    }

    /deep/ .el-form--label-top .el-form-item__label {
      padding: unset;
    }
  }

  /deep/ .el-dialog__header {
    border-bottom: 1px solid #dddddd;
  }

  /deep/ .el-dialog__footer {
    background: #f5f5f5;
    height: 70px;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    padding: 0 30px;
  }

  /deep/ .el-form-item {
    margin-bottom: 10px;
  }

  /deep/ .el-dialog__body {
    padding: 5px 20px 30px;
  }

  .dialog-footer {
    /deep/ .el-button--primary {
      width: 100px;
      background: #f39020;
    }

    /deep/ .el-button {
      padding: unset;
      width: 100px;
      height: 32px;
      border-radius: unset;
    }
  }

  /deep/ .el-button--primary {
    border-color: unset;
  }

  .tip {
    margin: 53px 0 30px;
    display: flex;
    align-items: center;

    img {
      width: 22px;
      height: 22px;
    }

    span {
      margin-left: 7px;
      font-size: 14px;
      color: #262b36;
    }
  }
}
</style>
